import React from 'react';
import PropTypes from 'prop-types';
import './styles.less';

export const CargoFetchBadge = ({ text }) => {
	return <div className="cargo-fetch-badge">{text}</div>;
};

CargoFetchBadge.propTypes = {
	text: PropTypes.any.isRequired,
};
